@if (appendLabel) {
  <span class="p-datatable-label">{{ column.label }}</span>
}

@switch (column.type) {
  @case (TableColumnType.Ordinal) {
    <span>{{ order }}</span>
  }

  @case (TableColumnType.Select) {
    <app-table-body-current-page-row-selection-checkbox
      [dataKey]="dataKey"
      [disabled]="bodyRowSelectionDisabled"
      [model]="model" />
    <!--    <app-table-body-row-selection-checkbox-->
    <!--      [dataKey]="dataKey"-->
    <!--      [disabled]="bodyRowSelectionDisabled"-->
    <!--      [model]="model" />-->
  }
  @case (TableColumnType.Currency) {
    @if (shouldShowCurrency()) {
      <app-currency
        [amount]="amount"
        [currency]="currency" />
    } @else {
      <app-no-data />
    }
  }
  @case (TableColumnType.Number) {
    @if (shouldShowNumber()) {
      <app-number [value]="number" />
    } @else {
      <app-no-data />
    }
  }
  @case (TableColumnType.Boolean) {
    @if (shouldShowBoolean()) {
      <app-boolean [value]="boolean" />
    } @else {
      <app-no-data />
    }
  }
  @case (TableColumnType.Date) {
    @if (shouldShowDate()) {
      <app-date [date]="date" />
    } @else {
      <app-no-data />
    }
  }
  @case (TableColumnType.DateTime) {
    @if (shouldShowDateTime()) {
      <app-date-time [date]="dateTime" />
    } @else {
      <app-no-data />
    }
  }
  @case (TableColumnType.Custom) {
    @if (customCellTemplateRef) {
      <ng-container
        [ngTemplateOutletContext]="{ model: model, column: column }"
        [ngTemplateOutlet]="customCellTemplateRef" />
    } @else {
      Brak referencji dla szablonu komórki.
    }
  }
  @default {
    @if (shouldShowText()) {
      {{ text }}
    } @else {
      <app-no-data />
    }
  }
}
